<template>
    <div class="index">
        <van-nav-bar title="用户观看记录" fixed placeholder left-arrow @click-left="onClickLeft" />
        <van-search style="margin-bottom: var(--base-px-12)" v-model="nickname" show-action placeholder="请输入用户名称"
            @search="onSearch">
            <template #action>
                <van-button type="info" icon="search" size="small" @click="onSearch">搜索</van-button>
            </template>
        </van-search>
        <div class="filters">
            <van-tabs v-model="types" @change="onTypeChange" line-width="var(--base-px-24)" color="#1989fa">
                <van-tab title="全部" name=""></van-tab>
                <van-tab title="直播" name="1"></van-tab>
                <van-tab title="回放" name="2"></van-tab>
            </van-tabs>
        </div>
        <div class="content">
            <List v-model="loading" :finished="finished" :error="loadError" :error-text="loadErrorText"
                finished-text="没有更多了" @load="onLoad">
                <div v-for="item in list" :key="item.id" class="user-card">
                    <div class="user-card-content">
                        <img class="user-avatar" :src="item.user && item.user.avatar" alt="用户头像" />
                        <div class="user-info">
                            <div class="user-name">
                                {{ item.user && item.user.nickname }}
                            </div>
                            <div class="user-details">
                                <div class="detail-item">
                                    <span class="detail-label">直播观看时长：</span>
                                    <span class="detail-value">{{ item.duration }}秒</span>
                                </div>
                                <div class="detail-item" v-if="Number(item.replay_time) > 0">
                                    <span class="detail-label">直播回放观看时长：</span>
                                    <span class="detail-value">{{
                                        item.replay_time
                                    }}秒</span>
                                </div>
                                <div class="detail-item" v-if="item.ads_time">
                                    <span class="detail-label">广告观看时间：</span>
                                    <span class="detail-value">{{
                                        item.ads_time
                                    }}</span>
                                </div>
                                <div class="detail-item" v-if="item.ads_duration > 0">
                                    <span class="detail-label">广告观看时长：</span>
                                    <span class="detail-value">{{
                                        item.ads_duration
                                    }}秒</span>
                                </div>
                                <div v-if="item.wa_view_sign_in && Array.isArray(item.wa_view_sign_in)">
                                    <div class="detail-item" v-for="(sign, index) in item.wa_view_sign_in"
                                        :key="sign.id">
                                        <span class="detail-label">第{{ index + 1 }}次签到时间：</span>
                                        <span class="detail-value">{{
                                            sign.sign_time
                                        }}</span>
                                    </div>
                                </div>
                                <div class="detail-item" v-if="item.province || item.city">
                                    <span class="detail-label">地区：</span>
                                    <span class="detail-value">
                                        {{ item.province_city }}
                                    </span>
                                </div>
                                <div class="detail-btns">
                                    <van-button type="info" size="small" v-if="item.is_reissue != 1"
                                        @click="oneResendRedPacket(item.user_id)">补发红包</van-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </List>
        </div>
    </div>
</template>
<script>
import { List } from "vant";
import { liveRoomGetUserViewist, resendRedPacket } from "@/api/live";
export default {
    name: "watchData",
    components: {
        List,
    },
    data() {
        return {
            id: "",
            pages: 1,
            page_size: 10,
            total: 0,
            list: [],
            finished: false,
            loading: false,
            loadError: false,
            loadErrorText: "",
            nickname: "",
            // types：1=直播，2=回放；不传即为全部
            types: "",
        };
    },
    created() {
        this.id = this.$route.query.id;
        this.getList();
    },
    methods: {
        onTypeChange() {
            this.pages = 1;
            this.list = [];
            this.finished = false;
            this.loading = false;
            this.loadError = false;
            this.loadErrorText = "";
            this.getList();
        },
        onSearch() {
            this.pages = 1;
            this.list = [];
            this.finished = false;
            this.loading = false;
            this.loadError = false;
            this.loadErrorText = "";
            this.getList();
        },
        onClickLeft() {
            this.$router.back();
        },
        onLoad() {
            this.pages++;
            this.getList();
        },
        oneResendRedPacket(user_id) {
            this.$dialog
                .confirm({
                    title: "提示",
                    message: "确定要补发红包吗？",
                })
                .then((res) => {
                    if (res) {
                        this.resendRedPacket(user_id);
                    }
                });
        },
        resendRedPacket(user_id) {
            resendRedPacket({
                userid: user_id,
                room_id: this.id,
            }).then((res) => {
                if (res.data.result.data.code == 1) {
                    this.$toast.success(res.data.result.data.msg);
                    this.getList()
                } else {
                    this.$toast.fail(res.data.result.data.msg);
                }
            });
        },
        getList() {
            this.loading = true;
            const payload = {
                room_id: this.id,
                page: this.pages,
                limit: this.page_size,
                nickname: this.nickname,
            };
            if (this.types) {
                payload.types = Number(this.types);
            }
            liveRoomGetUserViewist(payload)
                .then((res) => {
                    if (res.code == 1) {
                        if (res.data.count <= this.pages * 10) {
                            this.finished = true;
                        } else {
                            this.finished = false;
                        }
                        if (this.pages == 1) {
                            this.list = []
                        }
                        this.list = [...this.list, ...res.data.list];
                        this.total = res.data.total;
                        this.loadError = false;
                        this.loadErrorText = "";
                    } else {
                        this.$toast.fail(res.msg);
                        this.loadError = true;
                        this.loadErrorText = res.msg;
                    }
                    this.loading = false;
                })
                .finally(() => {
                    this.loading = false;
                });
        },
    },
};
</script>
<style scoped lang="less">
.index {
    background: #f5f5f5;
    min-height: 100vh;
}

.filters {
    background: #fff;
    margin: var(--base-px-12) var(--base-px-12) 0;
    border-radius: var(--base-px-8);
    overflow: hidden;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
    padding-top: 0.4rem;
}

.content {
    padding: var(--base-px-12);
}

.user-card {
    background: #ffffff;
    border-radius: var(--base-px-8);
    margin-bottom: var(--base-px-12);
    padding: var(--base-px-16);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.user-card-content {
    display: flex;
    align-items: flex-start;
}

.user-avatar {
    width: var(--base-px-52);
    height: var(--base-px-52);
    border-radius: var(--base-px-100);
    margin-right: var(--base-px-12);
    flex-shrink: 0;
    object-fit: cover;
    background: #f0f0f0;
}

.user-info {
    flex: 1;
    min-width: 0;
}

.user-name {
    font-size: var(--base-px-16);
    font-weight: 500;
    color: #333333;
    margin-bottom: var(--base-px-8);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.user-details {
    display: flex;
    flex-direction: column;
    gap: var(--base-px-6);
}

.detail-item {
    font-size: var(--base-px-14);
    color: #666666;
    display: flex;
    align-items: center;
}

.detail-label {
    color: #999999;
    margin-right: var(--base-px-4);
}

.detail-value {
    color: #333333;
}

.detail-btns {
    display: flex;
    justify-content: flex-end;
    margin-top: var(--base-px-10);
}

/deep/ .van-search__action {
    line-height: 0;
}
</style>
